<template>
    <div :class="customClass" class="checkout-paymentMethod_option" v-if="!hidePaymentItem">
        <el-radio-group v-model="selectedPaymentMode">
            <el-radio class="paynowRadio" v-if="payNowLinkEligible" :label="label" border @change="onChange">
                <img v-if="!noBadge" class="recommendIcon" :src="assets.icon.recommendIcon"/>
                <strong>{{title}}</strong>
                <img v-if="image" :src="image" height="50px" class="my-3"/>
                <i v-else :class="'fa '+iconName" class="mb-3" aria-hidden="true"></i>
                <slot/>
            </el-radio>
        </el-radio-group>
    </div>
</template>

<script>
  import assets from "../../../assets/assets";

  export default {
    name: "PaymentBox",
    // components: {BModal},
    props: ["hidePaymentItem", "payNowLinkEligible", "passSelectedPaymentMode", "title", "iconName", "noBadge", "label", "handleEmit","customClass","image"],
    watch: {
      passSelectedPaymentMode: function(value) {
        if (value) {
          this.selectedPaymentMode = value;
        }
      }
    },
    mounted() {
      this.selectedPaymentMode = this.passSelectedPaymentMode;
    },
    data() {
      return {
        selectedPaymentMode: null,
        assets: assets
      };
    },
    methods: {
      onChange() {
        this.$emit("handleEmit", this.selectedPaymentMode, "selectedPaymentMode");
      }
    }
  };
</script>